module.exports = __webpack_public_path__ + "static/media/20-1.102fd092.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/20-1.jpg
// module id = 1368
// module chunks = 0